import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../../environments/environment';
import { ReportAutomationComponent } from './report-automation/report-automation.component';

const routes: Routes = [
  {
    path: '',
    component: ReportAutomationComponent,
    data: {
      module: `${environment.modules.internalTools}/${environment.modules.reportAutomation}`,
      breadcrumbs: 'Report Automation'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportAutomationRoutingModule {}
